import { defineMessages } from 'react-intl';

export default defineMessages({
  plus_delivery: {
    id: 'app.modules.shopDetails.ShopHeader.PlusTag.plus_delivery',
    defaultMessage: 'Envío Gratis',
  },
  plus_delivery_pickup: {
    id: 'app.modules.shopDetails.ShopHeader.PlusTag.plus_delivery_pickup',
    defaultMessage: 'Gratis',
  },
});
